<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div id="Introduction">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=4></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div v-for="(item, index) in arrList" :key="index" class="maline">
                <h2 class="app-title">{{ item.title }}</h2>
                <p v-html="item.content"></p>
            </div>
            <!-- <h2>馆长致辞</h2>
            <img src="../assets/person.png" alt="" class="pic">
            <p>我是北京民生现代美术馆馆长某某某，</p>
            <p>2022年，东京国立博物馆迎来了创立150周年这一历史性的里程碑，我们在"与您共踏新旅程"的口号下，以多样的形式为广大观介是现了创立150周年的各项纪念活动。去年，为恢复本馆在新冠疫情前开展的全部工作，我们重启了夜间开馆日、互动式展示等活动。随着海外访日游客的增加，馆内也随处可见海外观众的身影。</p>
            <p>展望2024年，我们将以“可持续发展的博物馆”和"享誉世界的博物馆"为目标，逐步迈向下一个150年。其一，“可持续发展的博物馆”:为下一个150年做准备。在新冠疫情的影响下，我们不得不面对临时闭馆和参观者骤减等难题。经历了博物馆环境发生剧变的特殊时期，我们在前人奠定的基础上通过确立稳定的财政基础、积极利用先进技术、进行多方面的风险管理等经营战略，全面审视并优化博物馆的经营与管理，打造一个将人类共同的文化遗产传承至未来的可持续发展的博物馆。</p>
            <p>其二，"享誉世界的博物馆”: 为履行本馆作为日本文化据点之使命，加强与世界各地博物馆的联系与交流。东京国立博物馆作为代表日本的博物馆,不仅深受当地民众喜爱，还通过完善海外游客服务和举办海外展览等方式，致力于将本馆打造成足以引领世界博物馆的先锋。</p> -->
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { backheadTitles,} from "../utils/i18nLabels";
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);
    const titleLabel = computed(() => backheadTitles.introduction[currentLanguage.value || 'zh'])
    // 获取列表数据
    function getList() {
        let queryParams1 = {
            page: 1,
            pageSize: 100,
            pid: 12
        }
        getshowList(queryParams1).then(res => {
            const data = res.data
            data.list.map(item => {
                if(localStorage.getItem('userAgent') == 'Mobile'){
                    item.content = item.content.replace(/<img/g, '<img style="margin: 0 auto;display: block;width: 100%"')
                } else {
                    item.content = item.content.replace(/<img/g, '<img style="margin: 0 auto;display: block;width: 50%"')
                }
            })
            arrList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        console.log(currentLanguage.value)
        getList()
    })
</script>

<style scoped>
    #Introduction{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        /* text-align: left; */
        padding: 60px;
        .maline {

            max-width: 814px;
            margin: 0 auto;
        }
    }
    .pic{
        width: 100%;
        margin: 0 auto 60px;
        display: block;
    }
    h2{
        font-size: 30px;
        color: #232323;
        font-weight: normal;
        margin-bottom: 60px;
    }
    p{
        color: #000;
        line-height: 32px;
        margin-bottom: 20px;
        word-break: break-all;
    }

    .Mobileclass{
        padding: 22px;
        margin-top: 160px;
        h2{
            margin-bottom: 20px;
        }
    }
</style>